import { render } from "./HomeCard.vue?vue&type=template&id=5c0a6707&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=5c0a6707&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0a6707"]])

export default __exports__